
export const query_system_message = `
query getSystemMessage{
    system_message(limit:1){
        Id
        ShowMessage
        MessageAlert
        MessageVersion
        Version
    }
}`;